import { DataContainer } from './styles'

import handIcon from '../../assets/hand.svg';

export function DataHome() {
    return (
        <DataContainer>
            <h1>
                Jonas Borges
                <img src={handIcon} alt="Icone Olá" />
            </h1>
            <h2>Desenvolvedor Front-end</h2>
            <p>
                Apaixonado por tecnologia, que gosta de transformar problemas complexos em projetos simples, 
                bonitos e intuitivos.
            </p>
            <a href="#contact">
                Converse Comigo
                <i className="uil uil-message"></i>
            </a>
        </DataContainer>
    )
}